import { Link, useParams } from "react-router-dom";
import { FiArrowLeft, FiShoppingBag } from "react-icons/fi";
import { toast } from "react-toastify";
import axios from "axios";
import { useContext } from "react";
import { useQueryClient } from "react-query";
import UserDataFetcher from "../../../libs/getUserbyUserId";
import { AuthContext } from "../../../Context/AuthContext";
import PageHeader from "../../components/PageHeader";
import MerchantOrderDetail from "../components/MerchantOrderDetail";
import Spinner from "../../../Spinner/Spinner";
import useOrderDetail from "../hooks/useOrderDetail";

const MerchantOrderDetailPage = () => {
  const { orderId } = useParams();
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();
  const { data, isLoading, isError } = useOrderDetail(orderId);
  const { userData } = UserDataFetcher();
  const merchantId = userData?.user?.userId || userData?.user?._id;

  const order = data?.order;
  const returnRequest = data?.returnRequest;

  const handleReturnDecision = async (returnId, status) => {
    try {
      await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/order/returns/${returnId}`,
        { status },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success(`Return ${status}`);
      queryClient.invalidateQueries(["orderDetail", orderId]);
    } catch (err) {
      toast.error(err.response?.data?.message || "Could not update return");
    }
  };

  if (isLoading) {
    return (
      <>
        <Link to="/merchant/orders" className="dashboard-back-link">
          <FiArrowLeft aria-hidden="true" /> Back to orders
        </Link>
        <Spinner />
      </>
    );
  }

  if (isError || !order) {
    return (
      <>
        <Link to="/merchant/orders" className="dashboard-back-link">
          <FiArrowLeft aria-hidden="true" /> Back to orders
        </Link>
        <div className="dashboard-card">
          <p style={{ margin: 0, color: "var(--dash-danger)" }}>Order not found or you do not have access.</p>
        </div>
      </>
    );
  }

  return (
    <>
      <Link to="/merchant/orders" className="dashboard-back-link">
        <FiArrowLeft aria-hidden="true" /> Back to orders
      </Link>
      <PageHeader
        title={`Order ${order.orderNumber}`}
        subtitle="Fulfillment details and item status"
        icon={FiShoppingBag}
      />
      <div className="dashboard-card">
        <MerchantOrderDetail
          order={order}
          merchantId={merchantId}
          returnRequest={returnRequest}
          onReturnDecision={handleReturnDecision}
          onOrderUpdate={() => queryClient.invalidateQueries(["orderDetail", orderId])}
        />
      </div>
    </>
  );
};

export default MerchantOrderDetailPage;
